<app-navbar></app-navbar>

<div class="container-fluid course-page">
  <div class="row">
    <nav class="col-md-3 col-lg-2 d-md-block sidebar course-sidebar">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/electric-cars">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Electric Cars</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/design-and-manufacturing">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Design and Manufacturing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/auto-electrical">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Auto Electrical of an Electric Scooter</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" routerLink="/iot">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Internet of Things</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/charger-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Charger Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/solar-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Solar Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/welding">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Welding</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" class="col-md-9 col-lg-10 ms-sm-auto px-3 px-md-4 py-4 course-content">
      <section class="course-header">
        <p class="course-tag">FEA Course</p>
        <h1>FEA - Internet of Things in Electric Vehicles</h1>
        <p class="course-subtitle">Learn through guided lessons and complete the module resources and progress checkpoints.</p>
      </section>

      <section class="lesson-grid">
        <article class="lesson-card">
          <h4><span>01</span> Internet of Vehicles</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FInternet-of-Things-Josephine-Forson%2FJosephine%20(IOT%20IOV).mp4?alt=media&token=c4ea96b1-683f-47d4-ac88-a1c00b195757" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>02</span> Uses of IOT</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FInternet-of-Things-Josephine-Forson%2FJosephine%20(Uses%20Of%20IOT).mp4?alt=media&token=35580714-de4f-4352-8599-53b51df9ca34" type="video/mp4">
          </video>
        </article>

      </section>

      <section class="course-actions">
        <a class="btn solarorange" href="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FInternet-of-Things-Josephine-Forson%2FInternet%20Of%20Things%20in%20Electric%20Vehicles.pptx?alt=media&token=4da10a17-466e-4de0-a601-76a209b12012" target="_blank" rel="noopener noreferrer">
          Download Course Material
        </a>

        <a class="btn solarblue" href="https://forms.gle/ypQwSCw11UgR6PG98" target="_blank" rel="noopener noreferrer">
          Take Assessment
        </a>

        <button type="button" class="btn solarorange complete-btn" (click)="completed()">
          Mark Completed
        </button>
      </section>
    </main>
  </div>
</div>
